import api from '../../../services/api'
import type { BruktbilFilters } from '../useBruktbilFilters'

export interface KlasserRow {
  class_label: string
  count: number
  share_pct: number
  finans_andel_pct: number
  snittalder_ar: number | null
  medianalder_ar: number | null
  top_merke: string | null
  top_merker: string[]
  snitt_lanebelop: number | null
  median_lanebelop: number | null
  ut_av_fylke_pct: number | null
  snittalder_kjoper_ar: number | null
  avg_bilalder: number | null
  avg_kjoper_alder: number | null
}

export interface KlasserListResponse {
  rows: KlasserRow[]
}

export interface WeeklyPoint {
  week: string
  count: number
}

export interface ActorTypeShare {
  actor_type: string
  count: number
  share: number
}

export interface KlasseDrilldownResponse {
  class_label: string
  weekly_trend: WeeklyPoint[]
  actor_type_breakdown: ActorTypeShare[]
}

// Only the global filter fields are needed — narrow so callers don't have to
// supply the module-local merke/modell/aar state from useBruktbilFilters.
type GlobalParams = Pick<BruktbilFilters, 'from' | 'to' | 'klasse' | 'varebil' | 'omregistrering'> & { selgerPostnummer?: string | null; kjoperPostnummer?: string | null }

function geoParams(f: GlobalParams) {
  return {
    ...(f.selgerPostnummer ? { selger_postnummer: f.selgerPostnummer.split(',') } : {}),
    ...(f.kjoperPostnummer ? { kjoper_postnummer: f.kjoperPostnummer.split(',') } : {}),
  }
}

export function fetchKlasserTable(filters: GlobalParams): Promise<{ data: KlasserListResponse }> {
  return api.get('/bruktbil/klasser', {
    params: { from_date: filters.from, to_date: filters.to, klasse: filters.klasse, varebil: filters.varebil, omregistrering: filters.omregistrering || undefined, ...geoParams(filters) },
  })
}

export function fetchKlasseDrilldown(
  filters: GlobalParams,
  classLabel: string,
): Promise<{ data: KlasseDrilldownResponse }> {
  return api.get(`/bruktbil/klasser/${encodeURIComponent(classLabel)}`, {
    params: { from_date: filters.from, to_date: filters.to, klasse: filters.klasse, varebil: filters.varebil, omregistrering: filters.omregistrering || undefined, ...geoParams(filters) },
  })
}
